  $('.best-seller').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  infinite: true,
  slidesToScroll: 1,
  dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.featured').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 2,
  responsive: [
  {
    breakpoint: 1024,
  settings: {
  slidesToShow: 3,
  slidesToScroll: 2,
  arrows: false,
  infinite: true,
  dots: true
          }
        },
  {
    breakpoint: 600,
  settings: {
    slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
          }
        },
  {
    breakpoint: 480,
  settings: {
    slidesToShow: 1,
  slidesToScroll: 1
          }
        }
  ]
    });



$('.resmed-collection-slider').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 2,
  responsive: [
  {
    breakpoint: 1024,
  settings: {
  slidesToShow: 3,
  slidesToScroll: 2,
  arrows: false,
  infinite: true,
  dots: true
          }
        },
  {
    breakpoint: 600,
  settings: {
    slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
          }
        },
  {
    breakpoint: 480,
  settings: {
    slidesToShow: 1,
  slidesToScroll: 1
          }
        }
  ]
    });
  

$('.explore').slick({
  dots: false,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.help').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 2,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.related-products').slick({
  dots: true,
  infinite:false,
  arrows: false,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 3,
  responsive: [
  {
    breakpoint: 1024,
  settings: {
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  infinite: true,
  dots: true
          }
        },
  {
    breakpoint: 600,
  settings: {
    slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
          }
        },
  {
    breakpoint: 480,
  settings: {
    slidesToShow: 1,
  slidesToScroll: 1
          }
        }
  ]
    });

$('.related-products-prescription').slick({
  dots: true,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 1,
  draggable:false,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        draggable:false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots: true
      }
    }
  ]
});




 $('.main_images1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.thumb_images1'
});
$('.thumb_images1').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.main_images1',
  dots: false,
  centerMode:false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});


$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

$('.best-selle').slick({
  dots: true,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 1,
  draggable:false,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        draggable:false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        dots: true
      }
    }
  ]
});

$('.hdiewhdiu').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  infinite: true,
  slidesToScroll: 2,
  responsive: [
  {
    breakpoint: 1024,
  settings: {
  slidesToShow: 3,
  slidesToScroll: 2,
  arrows: true,
  infinite: true,
  dots: true
          }
        },
  {
    breakpoint: 600,
  settings: {
    slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
          }
        },
  {
    breakpoint: 480,
  settings: {
    slidesToShow: 1,
  slidesToScroll: 1
          }
        }
  ]
    });
$('.bb').slick({
  dots: true,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  infinite: true,
  slidesToScroll: 1,
  responsive: [
  {
    breakpoint: 1024,
  settings: {
  slidesToShow: 3,
  slidesToScroll: 2,
  arrows: true,
  infinite: true,
  dots: true
          }
        },
  {
    breakpoint: 600,
  settings: {
    slidesToShow: 2,
  slidesToScroll: 2,
    arrows: false,
          }
        },
  {
    breakpoint: 480,
  settings: {
    slidesToShow: 1,
  slidesToScroll: 1
          }
        }
  ]
    });


$(document).ready(function(){
       
        $(".collapse.show").each(function(){
        	$(this).prev(".card-header").find(".fas").addClass("fa-minus").removeClass("fa-plus");
        });
    
        $(".collapse").on('show.bs.collapse', function(){
        	$(this).prev(".card-header").find(".fas").removeClass("fa-plus").addClass("fa-minus");
        }).on('hide.bs.collapse', function(){
        	$(this).prev(".card-header").find(".fas").removeClass("fa-minus").addClass("fa-plus");
        });
    });


 $(document).ready(function() {
    $('body').on('click', '#RegisterForm .btn', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      
    });
  });






